<!--
 * @Description: In User Settings Edit
 * @Author: your kamui
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-10-09 16:59:43
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <el-tabs v-model="active" type="card" @tab-click="handleIsparent">
      <el-tab-pane label="直属经销商订单" name="1">
        <el-tabs v-model="status" type="card" @tab-click="handleClick">
          <el-tab-pane :label="all" name="-1"></el-tab-pane>
          <el-tab-pane :label="sended" :name="JSON.stringify(count[6].status)"></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[7]) | filte"
            :name="JSON.stringify(count[7].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[1]) | filte"
            :name="JSON.stringify(count[1].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[0]) | filte"
            :name="JSON.stringify(count[0].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[5])  | filte"
            :name="JSON.stringify(count[5].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[4]) | filte"
            :name="JSON.stringify(count[4].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[2])  | filte"
            :name="JSON.stringify(count[2].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[3])  | filte"
            :name="JSON.stringify(count[3].status)"
          ></el-tab-pane>
        </el-tabs>

        <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <el-form-item label="下单时间" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form1.start_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form1.end_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="支付方式">
            <el-select v-model="form1.pay_type">
              <el-option label="全部" value></el-option>
              <el-option label="线下支付" value="1"></el-option>
              <el-option label="微信支付" value="2"></el-option>
              <el-option label="扫码支付" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form1.key_type">
              <el-option label="全部" value></el-option>
              <el-option label="订单号" value="1"></el-option>
              <el-option label="产品编号" value="2"></el-option>
              <el-option label="产品名称" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="form1.keywords" clearable></el-input>
          </el-form-item>
          <el-form-item label="是否赠品:">
            <el-select v-model="form1.isgift">
              <el-option label="全部" value></el-option>
              <el-option label="赠品" value="1"></el-option>
              <el-option label="非赠品" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商:">
            <el-col :span="12">
              <el-input v-model="form1.to_sn" clearable></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 10px;">
              <el-button type="primary" @click="selectType()">选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(form1,1)">搜索</el-button>
            <el-button type="primary" @click="exportList(form1)">导出</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-bottom:10px;">
          订单总金额:
          <span class="red">{{allMoney}}</span>
        </div>
            <el-table
                  :data="tableData1"
                  style="width: 100%;margin-bottom: 20px"
                  border
                  fit
                  v-loading='loading'
                  max-height="500"
                  >
         
                  <el-table-column prop="stock_out_sn" label="订单号" fixed="left" width="180"></el-table-column>
                  <el-table-column prop="to_name" fixed="left" label="经销商名称" width="180"></el-table-column>
                  <el-table-column prop="to_sn" label="经销商编号"  width="180"></el-table-column>
                  <el-table-column prop="to_level_name" label="经销商级别" width="180"></el-table-column>
                  <el-table-column prop="to_sn" width="180" label="上级经销商编号"></el-table-column>
                  <el-table-column prop="to_name" width="180" label="上级经销商名称"></el-table-column>
                  <el-table-column prop="to_level_name" width="180" label="上级经销商级别"></el-table-column>
                  <el-table-column prop="total_stock_out_num" width="180" label="订单金额">
                    <template slot-scope="scope">
                      {{scope.row.total_price | filMoney}}
                    </template>
                  </el-table-column>

             
                  <el-table-column prop="to_address" label="收货地址"  width="180"></el-table-column>
                  <el-table-column prop="created_at" label="下单时间"  width="180"></el-table-column>
                  <el-table-column prop="order_notes" label="订单留言"  width="180"></el-table-column>
                  <el-table-column prop="product_sn" label="产品编号"  width="180"></el-table-column>
                  <el-table-column prop="product_name" label="产品名称">
                  </el-table-column>
                  <el-table-column prop="stock_out_num" label="下单数量" width="180">
                  </el-table-column>
                  <el-table-column prop="real_stock_out_num" label="实发数量">
                  </el-table-column>
                  <el-table-column prop="expiring_date" fixed="right"  label="状态">
                    <template slot-scope="scope">
                              <span v-if="scope.row.status == 0">未发货</span>
                              <span v-if="scope.row.status == 1">待收货</span>
                              <span v-if="scope.row.status == 2">发货中</span>
                              <span v-if="scope.row.status == 3">待付款</span>
                              <span v-if="scope.row.status == 4">待审核</span>
                              <span v-if="scope.row.status == 5">审核不通过</span>
                              <span v-if="scope.row.status == 6">已完成</span>
                              <span v-if="scope.row.status == 7">已取消</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="操作" fixed="right" width="180">
                    <template slot-scope="scope">
                        <!-- 0未发货 1已发货 2 部分发货 -->
                            <el-button
                              type="text"
                              size="small"
                              @click="detail(scope.row)"
                              v-if="scope.row.status!==4"
                            >查看详情</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="dealerOrderSave(scope.row)"
                              v-if="scope.row.status==1"
                            >发货</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="cancel(scope.row)"
                              v-if="scope.row.status==0"
                            >取消订单</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="inAdvance(scope.row,0)"
                              v-if="scope.row.status==1 && scope.row.stock_out_num!=scope.row.real_stock_out_num"
                            >撤销结单</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="inAdvance(scope.row,1)"
                              v-if="scope.row.status==2"
                            >提前结单</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="review(scope.row,1)"
                              v-if="scope.row.status==4"
                            >审核订单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="非直属经销商订单" name="2">
        <!-- @tab-click="" -->
        <el-tabs v-model="status" type="card" @tab-click="handleClick">
          <el-tab-pane :label="all" name="-1"></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[3])  | filte"
            :name="JSON.stringify(count[3].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[4]) | filte"
            :name="JSON.stringify(count[4].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[7]) | filte"
            :name="JSON.stringify(count[7].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[0]) | filte"
            :name="JSON.stringify(count[0].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[2])  | filte"
            :name="JSON.stringify(count[2].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[1]) | filte"
            :name="JSON.stringify(count[1].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[5])  | filte"
            :name="JSON.stringify(count[5].status)"
          ></el-tab-pane>
          <el-tab-pane
            :label="JSON.stringify(count[6])  | filte"
            :name="JSON.stringify(count[6].status)"
          ></el-tab-pane>
        </el-tabs>

        <el-form ref="form1" :model="form" label-width="120px" :inline="true">
          <el-form-item label="下单时间" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form.start_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form.end_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form.key_type">
              <el-option label="全部" value></el-option>
              <el-option label="订单号" value="1" :select="true"></el-option>
              <el-option label="产品编号" value="2"></el-option>
              <el-option label="产品名称" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.keywords" clearable></el-input>
          </el-form-item>

          <el-form-item label="支付方式">
            <el-select v-model="form.pay_type">
              <el-option label="全部" value></el-option>
              <el-option label="线下支付" value="1"></el-option>
              <el-option label="微信支付" value="2"></el-option>
              <el-option label="微信扫码支付" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model="form.product_name" clearable></el-input>
          </el-form-item>
          <el-form-item label="是否赠品:">
            <el-select v-model="form.isgift">
              <el-option label="全部" value></el-option>
              <el-option label="赠品" value="1"></el-option>
              <el-option label="非赠品" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商:">
            <el-col :span="12">
              <el-input v-model="form.from_superior_sn" clearable></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 10px;">
              <el-button type="primary" @click="selectType()">选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(form,1)">搜索</el-button>
            <el-button type="primary" @click="exportList(form)">导出</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-bottom:10px;">
          订单总金额:
          <span class="red">￥{{allMoney}}</span>
        </div>
        <div  style="width: 100%;margin-bottom: 20px; overflow:auto">
                <el-table
                  :data="tableData1"
                  style="width: 100%;margin-bottom: 20px"
                  border
                  fit
                  v-loading='loading'
                  max-height="500"
                  >
                  <el-table-column prop="id" label="序号" sortable fixed="left">
                    <template slot-scope="scope">
                      {{scope.row.id}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="stock_out_sn" label="订单号" fixed="left" width="180"></el-table-column>
                  <el-table-column prop="to_name" fixed="left" label="经销商名称" width="180"></el-table-column>
                  <el-table-column prop="to_sn" label="经销商编号"  width="180"></el-table-column>
                  <el-table-column prop="to_level_name" label="经销商级别" width="180"></el-table-column>
                  <el-table-column prop="from_superior_sn" width="180" label="上级经销商编号"></el-table-column>
                  <el-table-column prop="from_superior_name" width="180" label="上级经销商名称"></el-table-column>
                  <el-table-column prop="from_superior_level_name" width="180" label="上级经销商级别"></el-table-column>
                  <el-table-column prop="total_stock_out_num" width="180" label="订单金额">
                    <template slot-scope="scope">
                      {{scope.row.total_price | filMoney}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="total_stock_out_num" label="支付方式">
                    <template slot-scope="scope">
                      <span v-if="scope.row.pay_type == 1">线下支付</span>
                      <span v-if="scope.row.pay_type == 2">微信支付</span>
                      <span v-if="scope.row.pay_type == 3">微信扫码支付</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop label="是否赠品" width="180">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isgift == 1">赠品</span>
                      <span v-else>非赠品</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="to_address" label="收货地址"  width="180"></el-table-column>
                  <el-table-column prop="created_at" label="下单时间"  width="180"></el-table-column>
                  <el-table-column prop="order_notes" label="订单留言"  width="180"></el-table-column>
                  <el-table-column prop="product_sn" label="产品编号"  width="180"></el-table-column>
                  <el-table-column prop="product_name" label="产品名称">
                  </el-table-column>
                  <el-table-column prop="stock_out_num" label="下单数量" width="180">
                  </el-table-column>
                  <el-table-column prop="real_stock_out_num" label="实发数量">
                  </el-table-column>
                  <el-table-column prop="expiring_date" fixed="right"  label="状态">
                    <template slot-scope="scope">
                              <span v-if="scope.row.status == 0">未发货</span>
                              <span v-if="scope.row.status == 1">待收货</span>
                              <span v-if="scope.row.status == 2">发货中</span>
                              <span v-if="scope.row.status == 3">待付款</span>
                              <span v-if="scope.row.status == 4">待审核</span>
                              <span v-if="scope.row.status == 5">审核不通过</span>
                              <span v-if="scope.row.status == 6">已完成</span>
                              <span v-if="scope.row.status == 7">已取消</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="操作" fixed="right" width="180">
                    <template slot-scope="scope">
                        <!-- 0未发货 1已发货 2 部分发货 -->
                            <el-button
                              type="text"
                              size="small"
                              @click="detail(scope.row)"
                              v-if="scope.row.status!==4"
                            >查看详情</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="cancel(scope.row)"
                              v-if="scope.row.status==0"
                            >取消订单</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="inAdvance(scope.row,0)"
                              v-if="scope.row.status==1 && scope.row.stock_out_num!=scope.row.real_stock_out_num"
                            >撤销结单</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="inAdvance(scope.row,1)"
                              v-if="scope.row.status==2"
                            >提前结单</el-button>
                            <el-button
                              type="text"
                              size="small"
                              @click="review(scope.row,2)"
                              v-if="scope.row.status==4"
                            >审核订单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                </div>
   
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNo2"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize2"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!--选择经销商-->
    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
  </div>
</template>


<script>
import selectDealer from "../../common/selectDealer";
import handlerTable from '@/until/handlerTable'
export default {
  name: "myorder",
  data() {
    return {
      active: "1",
      showLink: false,
      selectDealerDialog: false,
      loading: false,
      activeName: " ",
      form1: {
        pay_type: "",
        to_sn: "",
        key_type: "",
        keywords: "",
        start_time: "",
        end_time: "",
        isgift: ""
      },
      form: {
        product_sn: "",
        product_name: "",
        role: "",
        isgift: "",
        custType: "",
        start_time: "",
        end_time: "",
        from_superior_sn: "",
        keywords:"",
        pay_type:"",
        key_type:""
      },
      tableData1: [],
      tableData2: [],
      is_parent: 1, // 1 直属  2非直属
      status: "-1", //订单状态
      //分页
      pageNo1: 1, //页码
      pageSize1: 10, //每页现实的条数
      totalSize1: 0, //总条数
      //分页
      pageNo2: 1, //页码
      pageSize2: 10, //每页现实的条数
      totalSize2: 0, //总条数
      count: [{}, {}, {}, {}, {}, {}, {}, {}],
      all: 0,
      allMoney: 0,
      done: "",
      sended: ""
    };
  },
  methods: {
    //选择经销商
    selectType() {
      this.selectDealerDialog = true;
    },
    getSelectinfo(val) {
      if (val.dealer_sn) {
        this.form1.to_sn = val.dealer_sn;
        this.form1.to_type = 2;
        
        this.form.from_superior_sn = val.dealer_sn;
         this.form.to_type = 2;
      } else {
        this.form.to_sn = val.shop_sn;
        this.form.to_type = 3;
      }
    },
    // 获取订单列表
    getList(data,p) {
    
      if (this.$route.query && this.$route.query.sn) {
        if (this.$route.query.is_parent == 1) {
          this.form1.key_type = "1";
          this.form1.keywords = this.$route.query.sn;
          this.active = "1";
        } else {
          this.form.key_type = "1";
          this.form.keywords = this.$route.query.sn;
          this.active = "2";
        }
      }

      if (this.active == 1) {
        var obj = this.form1;
      } else {
        // eslint-disable-next-line no-redeclare
        var obj = this.form;
      }

      this.loading = true;
      this.tableData1 = [];
      if (obj.start_time) {
        obj.start_time = this.moment(obj.start_time).format("YYYY-MM-DD");
      }
      if (obj.end_time) {
        obj.end_time = this.moment(obj.end_time).format("YYYY-MM-DD");
      }
      if (this.active == 1) {
        this.$get("logistics", "/dealers.orders", {
          is_parent: this.active,
          per_page: this.pageSize1,
          page: p?p:this.pageNo1,
          status: this.status==-1?"":this.status,
          ...obj
        })
          .then(res => {
            this.loading = false;
            this.allMoney=res.total_price
              this.tableData1 = handlerTable(res.data,{
                keys:'products'
              })
            this.pageNo1 = res.meta.current_page;
            this.pageNo2 = res.meta.current_page;
            this.totalSize1 = res.meta.total;
            this.totalSize2 = res.meta.total;
           
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "请输入正确的信息"
            });
          });
      } else {
        this.$get("logistics", "/dealers.orders", {
          is_parent: this.active,
          per_page: this.pageSize2,
          page: p?p:this.pageNo2,
          status: this.status==-1?"":this.status,
          ...obj
        })
          .then(res => {
            this.loading = false;
            this.pageNo1 = res.meta.current_page;
            this.pageNo2 = res.meta.current_page;
            this.totalSize1 = res.meta.total;
            this.totalSize2 = res.meta.total;
            this.allMoney=res.total_price
              this.tableData1 = handlerTable(res.data,{
                keys:'products'
              })
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "请输入正确的信息"
            });
          });
      }
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getList(this.form1);
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.getList(this.form1);
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;

      this.getList(this.form);
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.getList(this.form);
    },
    handleIsparent() {
      this.allMoney = 0;

      if (this.active == 1) {
        this.getList(this.form1);
      } else {
        this.getList(this.form);
      }
      this.getCount();
    },
    handleClick() {
      this.allMoney = 0;
      this.getList(this.form1);
    },
    exportList() {
      // localStorage.getItem('access_tokens')
      let beginstr = "",
        endstr = "";
      // eslint-disable-next-line no-unused-vars
      var page = "",
        // eslint-disable-next-line no-unused-vars
        per_page = "",
        obj = {};
      if (this.active == 1) {
        obj = this.form1;
        page = this.pageNo1;
        per_page = this.pageSize1;
      } else {
        obj = this.form;
        page = this.pageNo2;
        per_page = this.pageSize2;
      }
      if (obj.start_time) {
        beginstr = this.moment(obj.start_time).format("YYYY-MM-DD");
      }
      if (obj.end_time) {
        endstr = this.moment(obj.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");
 
      var status=this.status==-1?"":this.status
      if (this.active == 1) {
        window.open(
          this.$Base_Export+
            "/dealers.orders.export?start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&is_export=" +
            1 +
            "&is_parent=" +
            +this.active +
            "&status=" 
            +status+
            "&keywords=" +
            obj.keywords +
            "&key_type=" +
            obj.key_type +
            "&lang=" +
            "" +
            "&to_sn=" +
            obj.to_sn +
            "&pay_type=" +
            obj.pay_type +
            "&isgift=" +
            obj.isgift +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        window.open(
         this.$Base_Export+
            "/dealers.orders.export?start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&is_export=" +
            1 +
            "&is_parent=" +
            +this.active +
            "&status="
            +status+
            "&keywords=" +
            this.form.keywords +
            "&key_type=" +
            this.form.key_type +
            "&lang=" +
            "" +
            "&from_superior_sn=" +
            this.form.from_superior_sn +
            "&pay_type=" +
            this.form.pay_type +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    // 取消订单
    cancel(data) {
      this.$confirm("是否取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var url = "/dealers.orders/" + data.stock_out_sn?data.stock_out_sn:data.row_sn + "/cancel";
        this.$patch("logistics", url, {
          _method: "PATCH"
        })
          .then(res => {
            this.$message({
              type: "success",
              message: "成功"
            });
            if (this.active == 1) {
              this.getList(this.form1);
            } else {
              this.getList(this.form);
            }
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "取消失败"
            });
          });
      });
    },
    // 获取不同状态的 数量
    getCount() {
      this.$get("logistics", "/dealers.orders.count", {
        is_parent: this.active
      }).then(res => {
        var temp = 0;
        res.data.forEach(element => {
          temp += Number(element.total);
        });
        this.all = "全部(" + temp + ")";
        this.count = res.data;
        this.sended = "已发货(" + res.data[6].total + ")";
        this.countData = {};
      });
    },
    // 提前结单
    inAdvance(data, status) {
      this.$confirm(status == 0 ? "是否撤销订单?" : '"是否提前订单?"', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var url =  data.stock_out_sn?data.stock_out_sn:data.row_sn;
        this.$patch("logistics", "/dealers.orders/"+url, {
          _method: "PATCH",
          advance_order_status: status
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "成功"
            });
            if (this.active == 1) {
              this.getList(this.form1);
            } else {
              this.getList(this.form);
            }
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "取消失败"
            });
          });
      });
    },
    // 查看详情
    detail(data) {
      // console.log(data)
      this.$router.push({
        name: "dealerOrderDetail",
        query: { id: data.stock_out_sn?data.stock_out_sn:data.row_sn}
      });
    },
    // 查看详情
    dealerOrderSave(data) {
      this.$router.push({
        name: "dealerOrderSave",
        query: { order_line_no: data.stock_out_sn}
      });
    },
    // 查看审核
    review(data, temp) {
    
      this.$router.push({
        name: "dealeOrderReview",
        query: { id: data.stock_out_sn?data.stock_out_sn:data.row_sn, is_parent: temp }
      });
    }
  },
  filters: {
    filte: function(value) {
      var str = "";
        var total 
      if (!value) {
        return;
      } else {
        value = JSON.parse(value);
        switch (value.status) {
          case 0:
             total = value.total ? value.total : "0";

            str = "未发货(" + total + ")";

            break;
          case 1:
             total = value.total ? value.total : "0";

            str = "待收货(" + total + ")";

            break;
          case 2:
             total = value.total ? value.total : "0";
            str = "发货中(" + total + ")";

            break;
          case 3:
             total = value.total ? value.total : "0";
            str = "待付款(" + total + ")";

            break;
          case 4:
             total = value.total ? value.total : "0";
            str = "待审核(" + total + ")";

            break;
          case 5:
             total = value.total ? value.total : "0";
            str = "审核不通过(" + total + ")";

            break;
          case 6:
             total = value.total ? value.total : "0";

            str = "已完成(" + total + ")";

            break;
          case 7:
             total = value.total ? value.total : "0";
            str = "已取消(" + total + ")";
            break;
        }
      }

return str;
    },
    filMoney: function(val) {
      //    window.allMoney=Number(window.allMoney)+parseInt(val)

      //    console.log(window.allMoney,parseInt(val))
      return val;
    }
  },
  created() {
    this.getList();
    this.getCount();
  },
  components: {
    selectDealer
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  overflow-x: scroll;
  .table {
    width: 300%;
    tr {
      min-height: 57px;
      td {
        padding: 12px 6px;
      }
    }
  }
}
.red {
  color: #f04635;
}
</style>